<template>
  <div class="login_back">
    <div class="login_body">
      <div class="left_img">
        <img src="@/assets/people.png"/>
        <div class="detail_css">
          《电力大数据》是我们国家统一管理、公开出版发行的学术期刊，由贵州电网有限责任公司电力科学研究院与贵州省电机工程学会联合主办，国际标准连续出版物号为ISSN2096-4633，中国标准连续出版物号为CN
          52-1170/TK。该刊面向全国高等院校、电力科研院所、电力企业及广大电力工程技术人员发行，所刊论文被中国知网、万方、超星、维普等数据库收录。
        </div>
      </div>
      <div class="rig_login">
        <div class="login_title">
          《电力大数据》论文投稿注册
        </div>
        <el-form ref="ruleForm" :rules="submitDataRules" label-width="100px" style="width: 350px;margin: 0 auto"
                 :model="submitData"
                 label-position="left">
          <el-form-item prop="username" required label="邮箱/用户名">
            <el-row>
              <el-col :span="20">
                <el-input v-model="submitData.username" placeholder="请输入邮箱"/>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="sendMail" style="height: 40px;margin-left: 5px">
                  {{ buttonTime > 59.9 ? '发送验证码' : buttonTime }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="code" required label="验证码">
            <el-input v-model="submitData.code" placeholder="请输入邮箱验证码"/>
          </el-form-item>
          <el-form-item prop="password" required label="密码">
            <el-input class="inp" v-model="submitData.password" type="password"
                      placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item prop="nick_name" required label="真实名字">
            <el-input class="inp" v-model="submitData.nick_name"
                      placeholder="请输入真实名字"/>
          </el-form-item>
          <el-form-item prop="mobile" required label="电话号码">
            <el-input class="inp" v-model="submitData.mobile"
                      placeholder="请输入电话号码"/>
          </el-form-item>
          <el-form-item prop="company" required label="企业名称">
            <el-input class="inp" v-model="submitData.company"
                      placeholder="请输入企业名称"/>
          </el-form-item>
          <el-form-item prop="job" required label="工作岗位">
            <el-input class="inp" v-model="submitData.job"
                      placeholder="请输入工作岗位"/>
          </el-form-item>
          <el-form-item>
            <div>
              <el-button class="bton" @click="submit()" type="primary">提交</el-button>
              <el-button class="bton" @click="$router.push('/')" type="info">返回</el-button>
            </div>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import {register, sendEmail} from "@/api/index";
import {isEmail} from '@/utils/validate'

export default {
  name: "login",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== '') {
        if (value.length < 8) {
          callback(new Error('请输入至少8位的密码'))
          return false
        } else if (
            !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@!*#$%&_=])[A-Za-z\d@!*#$%&_=]{8,18}$/.test(value)
        ) {
          callback(new Error('密码必须包含字母、数字和特殊字符'))
          return false
        } else {
          callback()
        }
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error('邮箱格式错误'))
      } else {
        callback()
      }
    }
    /*    const isEmail = (rule, value, callback) => {
          const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
          if (value == '' || value == undefined || value == null) {
            callback();
          } else {
            if (!reg.test(value)) {
              callback(new Error('请输入正确的邮箱地址'));
            } else {
              callback();
            }
          }
        }*/
    return {
      buttonTime: 60,
      submitData: {
        username: "",
        password: "",
        nick_name: "",
        mobile: "",
        company: "",
        job: "",
        code: ''
      },
      submitDataRules: {
        username: [
          {required: true, message: '请填写邮箱', trigger: 'blur',},
          {validator: validateEmail, trigger: 'blur'},
          {type: 'string', message: '长度不能超过30位', trigger: 'blur', max: 30}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePassword, trigger: 'blur'}
        ],
        nick_name: [
          {required: true, message: '请输入真实名字', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
        company: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur'}
        ],
        job: [
          {required: true, message: '请输入岗位名称', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur'}
        ]
      },
    }
  },
  methods: {
    sendMail() {
      let interval = setInterval(() => {
        this.buttonTime = this.buttonTime - 1
        if (this.buttonTime < 1) {
          this.buttonTime = 60
          clearInterval(interval)
        }
      }, 1000)
      if (this.submitData.username.length > 0 && this.buttonTime == 60) {
        sendEmail({email: this.submitData.username}).then(res => {
          if (res) {
            this.$notify({
              type: 'success',
              title: "成功",
              message: "发送成功,请查看邮箱"
            })
            console.log(res)
          }
        })
      }
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          register(this.submitData).then(res => {
            if (res.code == 200) {
              this.$notify({title: '恭喜', type: 'success', message: "注册成功"})
              this.$router.push('/')
            }
          })
        }
      })
    },
    isNull(data) {
      if (data == undefined) {
        return false
      }
      if (data == null) {
        return false
      }
      if (data == "") {
        return false
      }
      return true
    },
  }
}
</script>

<style scoped>


.bton {
  display: inline-block;
  margin: 0 15px;
}

.login_back {
  height: 100vh;
  width: 100%;
  background: url("~@/assets/backimg.png") no-repeat;
  background-size: 100% 100%;
}

.login_body {
  width: 80%;
  background: white;
  position: relative; /*脱离文档流*/
  top: 50%; /*偏移*/
  transform: translateY(-50%);
  padding: 80px 0;
  margin: 0 auto;
  border-radius: 87.28px;
}

.left_img {
  width: 55%;
  display: inline-block;
  vertical-align: middle;
  padding: 20px 0 0 0;
}

.left_img img {
  height: 50%;
  width: 50%;
  object-fit: cover;
}

.rig_login {
  display: inline-block;
  vertical-align: middle;
  width: 44%;
  position: relative;
}

.rig_login .top_solicit {
  color: #fc132a;
  font-size: 14px;
  margin-top: 10px;
}

.login_title {
  font-size: 25px;
  font-weight: 600;
  text-align: center;
  color: #0099FF;
  margin-bottom: 20px;
}

.el-select .el-input {
  width: 460px;
}

.detail_css {
  padding: 0 50px;
  color: #0099FF;
  font-size: 14px;
}

</style>
